import { gql, useMutation, useLazyQuery, useQuery } from '@apollo/client'

export const GOOGLE_SIGN_IN = gql`
  mutation googleSignIn($idToken: String!) {
    googleSignIn(idToken: $idToken) {
      jwt
      oauthToken
    }
  }
`
export const useGoogleSignIn = opts => useMutation(GOOGLE_SIGN_IN, opts)

export const LINK_NEAT_ACCOUNT_WITH_GOOGLE = gql`
  mutation linkNeatAccountWithGoogle($idToken: String! $password: String!) {
    linkNeatAccountWithGoogle(idToken: $idToken, password: $password)
  }
`
export const useLinkNeatAccountWithGoogle = opts => useMutation(LINK_NEAT_ACCOUNT_WITH_GOOGLE, opts)

export const RECOVER_PASSWORD = gql`
  mutation recoverPassword($email: String! $callbackUrl: String!) {
    recoverPassword(email: $email, callbackUrl: $callbackUrl)
  }
`
export const useRecoverPassword = opts => useMutation(RECOVER_PASSWORD, opts)

export const RESET_PASSWORD = gql`
  mutation resetPassword($token: String! $newPassword: String!) {
    resetPassword(token: $token newPassword: $newPassword)
  }
`
export const useResetPassword = opts => useMutation(RESET_PASSWORD, opts)

export const LINK_NEAT_ACCOUNT_WITH_INTUIT = gql`
  mutation linkNeatAccountWithIntuit($tempToken: String! $username: String! $password: String!) {
    linkNeatAccountWithIntuit(tempToken: $tempToken, username: $username, password: $password) {
      jwt
      oauthToken
    }
  }
`
export const useLinkNeatAccountWithIntuit = opts => useMutation(LINK_NEAT_ACCOUNT_WITH_INTUIT, opts)

export const GET_JWT = gql`
  mutation getJwtFromOauthToken($oauthToken: String!) {
    getJwtFromOauthToken(oauthToken: $oauthToken) {
      jwt
    }
  }
`
export const useGetJwt = opts => useMutation(GET_JWT, opts)

export const GET_USER_WITH_ACCOUNTS = gql`
  query getUserWithAccounts($token: String!) {
    getUserWithAccounts(token: $token) {
      id
      firstName
      lastName
      accounts {
        id
        name
        role
        needsReviewCount
        unfiledCount
        dateJoined
      }
      primaryAccount {
        id
        plan {
          name
          id
          endDate
          isTeflon
        }
        role
        planFeatures {
          FilesFeature {
            enabled
          }
        }
      }
      billingStatus {
        status
      }
    }
  }
`
export const useGetUserWithAccounts = opts => useLazyQuery(GET_USER_WITH_ACCOUNTS, opts)

export const SELECT_ACCOUNT = gql`
  mutation selectAccount($oauthToken: String! $accountId: String!) {
    selectAccount(oauthToken: $oauthToken, accountId: $accountId) {
      summary {
        id
        plan {
          name
          id
          endDate
          isTeflon
        }
        role
        planFeatures {
          FilesFeature {
            enabled
          }
        }
      }
      billingStatus {
        status
      }
      jwt
    }
  }
`
export const useSelectAccount = opts => useMutation(SELECT_ACCOUNT, opts)

export const GET_CLIENT_CONFIG = gql`
  query getClientConfig($clientId: String!) {
    getClientConfig(clientId: $clientId) {
      recaptchaEnabled
    }
  }
`
export const useGetClientConfig = opts => useQuery(GET_CLIENT_CONFIG, opts)

export const SSO_LOGIN = gql`
 mutation ssoLogin($tempToken: String!) {
    ssoLogin(tempToken: $tempToken) {
      jwt
      oauthToken
    }
  }
`
export const useSSOLogin = opts => useMutation(SSO_LOGIN, opts)

export const CREATE_FREE_ACCOUNT = gql`
 mutation createFreeAccount($input: CreateFreeAccountInput!) {
    createFreeAccount(input: $input) {
      tokens {
        jwt
        oauthToken
        refreshJWT
        jwtExpiresAt
        refreshJWTExpiresAt
      }
      orderValidation {
        status
        user {
          neatUserId
        }
        error {
          status
          message
          type
        }
      }
      createdOrder {
        id
      }
      createdUser {
        id
    }
    }
  }
`
export const useCreateFreeAccount = opts => useMutation(CREATE_FREE_ACCOUNT, opts)

export const GET_OAUTH_CODE = gql`
 mutation getOauthCode($input: GetOauthCodeInput!) {
    getOauthCode(input: $input) {
      code
      clientName
      requestConfirmation
    }
  }
`
export const useGetOauthCode = opts => useMutation(GET_OAUTH_CODE, opts)

/* V3 */
export const SIGN_IN_V3 = gql`
  mutation signInV3($username: String! $password: String! $scope: Scope! $rId: String! $automationScope: String $forceValidationCode: Int) {
    signInV3(username: $username, password: $password, scope: $scope, rId: $rId, automationScope: $automationScope, forceValidationCode: $forceValidationCode) {
      tokens {
        jwt
        oauthToken
        refreshJWT
        jwtExpiresAt
        refreshJWTExpiresAt
      }
      validation {
        id
        expiresAt
      }
      mfaEnabled
    }
  }
`
export const useSignInV3 = opts => useMutation(SIGN_IN_V3, opts)

export const GOOGLE_SIGN_IN_V3 = gql`
  mutation googleSignInV3($idToken: String! $scope: Scope!) {
    googleSignInV3(idToken: $idToken, scope: $scope) {
      jwt
      oauthToken
      refreshJWT
      jwtExpiresAt
      refreshJWTExpiresAt
    }
  }
`
export const useGoogleSignInV3 = opts => useMutation(GOOGLE_SIGN_IN_V3, opts)

export const LINK_NEAT_ACCOUNT_WITH_INTUIT_V3 = gql`
  mutation linkNeatAccountWithIntuitV3($tempToken: String! $username: String! $password: String! $scope: Scope!) {
    linkNeatAccountWithIntuitV3(tempToken: $tempToken, username: $username, password: $password, scope: $scope) {
      jwt
      oauthToken
      refreshJWT
      jwtExpiresAt
      refreshJWTExpiresAt
    }
  }
`
export const useLinkNeatAccountWithIntuitV3 = opts => useMutation(LINK_NEAT_ACCOUNT_WITH_INTUIT_V3, opts)

export const GET_JWT_V3 = gql`
  mutation getJwtFromOauthTokenV3($oauthToken: String! $scope: Scope!) {
    getJwtFromOauthTokenV3(oauthToken: $oauthToken, scope: $scope) {
      jwt
      refreshJWT
      jwtExpiresAt
      refreshJWTExpiresAt
    }
  }
`
export const useGetJwtV3 = opts => useMutation(GET_JWT_V3, opts)

export const SSO_LOGIN_V3 = gql`
 mutation ssoLoginV3($tempToken: String! $scope: Scope!) {
    ssoLoginV3(tempToken: $tempToken, scope: $scope) {
      jwt
      refreshJWT
      jwtExpiresAt
      refreshJWTExpiresAt
      oauthToken
    }
  }
`
export const useSSOLoginV3 = opts => useMutation(SSO_LOGIN_V3, opts)

export const VALIDATE_SIGN_IN_MFA_CODE = gql`
 mutation validateSignInMFACode($code: String! $validationId: String!) {
    validateSignInMFACode(code: $code, validationId: $validationId) {
      jwt
      refreshJWT
      jwtExpiresAt
      refreshJWTExpiresAt
      oauthToken
    }
  }
`
export const useValidateSignInMFACode = opts => useMutation(VALIDATE_SIGN_IN_MFA_CODE, opts)

export const RESEND_SIGN_IN_MFA_CODE = gql`
 mutation resendSignInMFACode($validationId: String!) {
    resendSignInMFACode(validationId: $validationId) {
      id
      expiresAt
    }
  }
`
export const useResendSignInMFACode = opts => useMutation(RESEND_SIGN_IN_MFA_CODE, opts)
